import React from "react";
import { ensure } from "sprint-common-web";

import { OrderAuditItem } from "../AuditItem";
import { renderDateChangeInfo, renderSimpleChangeInfo } from "./renderAuditInfo";

export const DeliveryInfoChangeInfo: React.FunctionComponent<{ item: OrderAuditItem }> = ({
    item
}: {
    item: OrderAuditItem;
}) => {
    const { deliveryInfo } = item;

    ensure(deliveryInfo, "Missing delivery info");

    const { dueDate, deliveryDetails, deliveryTo } = deliveryInfo;
    return (
        <>
            {!!dueDate &&
                renderDateChangeInfo({
                    from: dueDate?.from,
                    to: dueDate?.to,
                    label: "Due date:"
                })}

            {!!deliveryDetails &&
                renderSimpleChangeInfo({
                    from: deliveryDetails?.from,
                    to: deliveryDetails.to,
                    label: "Delivery details:"
                })}

            {!!deliveryTo &&
                renderSimpleChangeInfo({ from: deliveryTo?.from, to: deliveryTo.to, label: "Delivery to:" })}
        </>
    );
};
